export default __webpack_public_path__ + "static/media/gng-visivo-acustico-step2.8279a4f8.svg";